<template>
  <div class="card">
    <h3 align="center" class="custom-font-motivation-blue">{{title}}</h3>

    <b-input-group size="sm">
      <b-input-group-prepend is-text>
        <b-icon icon="people"></b-icon>
      </b-input-group-prepend>
      <b-form-input type="text" placeholder="Nume" v-model="form.nume"></b-form-input>
    </b-input-group>
    <b-input-group size="sm">
      <b-input-group-prepend is-text>
        <b-icon icon="phone"></b-icon>
      </b-input-group-prepend>
      <b-form-input type="text" placeholder="Telefon" v-model="form.telefon"></b-form-input>
    </b-input-group>
    <b-input-group size="sm">
      <b-input-group-prepend is-text>
        <b-icon icon="link"></b-icon>
      </b-input-group-prepend>
      <b-form-input type="text" placeholder="Website" v-model="form.website"></b-form-input>
    </b-input-group>
    <b-input-group size="sm">
      <b-input-group-prepend is-text>
        <b-icon icon="envelope"></b-icon>
      </b-input-group-prepend>
      <b-form-input type="email" placeholder="me@example.com" v-model="form.email"></b-form-input>
    </b-input-group>
    <b-input-group size="sm">
      <b-input-group-prepend is-text>
        <b-icon icon="text-left"></b-icon>
      </b-input-group-prepend>
      <b-form-textarea
        rows="7"
        id="textarea-large"
        size="sm"
        placeholder="Mesaj"
        v-model="form.msg"
      ></b-form-textarea>
    </b-input-group>
    <b-input-group class="custom-form-submit-button">
      <b-button
        variant="secondary"
        align="center"
        @click="openMailTo(contactmail, form)"
      >Trimite</b-button>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: "ContactForm",
  props: {
      title: {type: String}
  },
  data() {
    return {
      form: {
        title: "Solicit contact",
        nume: "",
        telefon: "",
        website: "",
        email: "",
        msg: "",
      },
      contactmail: "accesibil@motivation.ro",
    };
  },
  methods: {
    openMailTo(email, body) {
      let content = `${body.nume}\n${body.telefon}\n${body.website}\n${body.email}\n${body.msg}`;
      window.open(
        `mailto:${email}?subject=${body.title}&body=${encodeURIComponent(
          content
        )}`
      );
    },
  },
};
</script>

<style scoped>
.custom-form-submit-button {
  margin: 0 auto;
  justify-content: center;
  padding: 5px;
}
.custom-font-motivation-blue {
  color: #123d74;
}
</style>